import React, { useEffect } from "react";

import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";
import { useNewGlobalSearchService } from "pages/[tenant]/search/hooks/useNewGlobalSearchService/useNewGlobalSearchService";

import CircularLoader from "shared/components/atoms/CircularLoader";
import { SearchInput } from "shared/components/atoms/SearchInput";

import SingleAuthor from "../../atoms/SingleAuthor";
import { AuthorsSectionContainer, Empty, SearchInputContainer } from "./styles";

const AuthorsSection = () => {
  const {
    authorsList,
    authorToIterate,
    authorWasFounded,
    searchAuthors,
    clearSearchAuthor,
  } = useNewGlobalSearch();

  const { getAuthors, isLoading } = useNewGlobalSearchService();

  useEffect(() => {
    if (authorsList?.length <= 0) getAuthors();

    return () => clearSearchAuthor();
  }, []);

  return (
    <AuthorsSectionContainer>
      <h3>Filtrar por autor:</h3>

      <SearchInputContainer>
        <SearchInput
          clearSearchMethod={clearSearchAuthor}
          searchListMethod={searchAuthors}
          withSearchAndXIcon
          placeholder="Pesquise por nome"
        />
      </SearchInputContainer>

      <div className="authors-list">
        {authorWasFounded ? (
          authorToIterate?.map((author) => (
            <SingleAuthor author={author} key={author?.id} />
          ))
        ) : (
          <Empty>Nenhum autor foi encontrado.</Empty>
        )}
      </div>

      {isLoading?.GETTING_AUTHORS && (
        <div className="loader">
          <CircularLoader />
        </div>
      )}
    </AuthorsSectionContainer>
  );
};

export default AuthorsSection;
